import { render, staticRenderFns } from "./AddColumn.vue?vue&type=template&id=87464b8a&"
import script from "./AddColumn.vue?vue&type=script&lang=js&"
export * from "./AddColumn.vue?vue&type=script&lang=js&"
import style0 from "./AddColumn.vue?vue&type=style&index=0&id=87464b8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports